export const DEFAULT_SEARCH_PAGE_SIZE = 24;
export const PAGE_SIZE_OPTIONS = [24, 48, 96];

/**
 * Fields required for product cards on listing surfaces.
 * Specified explicitly because headless defaults to MinimumFieldsToInclude
 * (7 system fields) when fieldsToInclude is not provided.
 * The Atomic path registers these via AtomicSearchInterface.fieldsToInclude;
 * the headless path needs them on the result-list controller directly.
 */
export const LISTING_FIELDS_TO_INCLUDE = [
  'ec_sale',
  'ec_name',
  'ec_thumbnails',
  'ec_price',
  'ec_price_filter',
  'ec_rating',
  'ec_rating_count',
  'ec_category',
  'publisher_name',
  'publisher_id',
  'ec_product_id',
  'ec_tags',
  'ec_is_new_release',
  'min_unity_version',
  'ec_flash_teaser_starts_at',
  'ec_flash_promo_starts_at',
];
